import React from 'react'
import Back from '../common/Back'
import Testimonial from './Testimonial'

const TestimonialMain = () => {
    return (
        <div>
            <Back title='Testimonial'/>
            <Testimonial />
        </div>
    )
}

export default TestimonialMain
